/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2026] Narbase Technologies
 * All Rights Reserved.
 * Created by shalaga44
 * On: 21/Sep/2026.
 */

@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.favoritepoints

import com.narbase.letsgo.router.EndPoint

object ReindexFavoritePointsSearchEndpoint :
    EndPoint<ReindexFavoritePointsSearchEndpoint.Request, ReindexFavoritePointsSearchEndpoint.Response>() {
    class Request()

    class Response(
        val isActive: Boolean,
        val indexedFavoritePointsCount: Int,
    )
}
